import { useAuth } from '../context/auth-context';
import React, { useEffect, useState } from 'react';
import { Modal, Box, Tab, Tabs, TextField, Button } from '@mui/material';
import FormGenerator from './formGenerator';
import { toast } from "react-toastify";
import axios from 'axios';
import { rootUrl } from '../helpers';
const LoginSignupModal = ({ open, handleClose }) => {
  const [tabIndex, setTabIndex] = useState(0);

  const auth = useAuth()

  const handleTabChange = (newValue) => {
    setTabIndex(newValue);
  };



  const handleLoginSubmit = async (data) => {

    auth.login(data, () => {
      handleClose()
      window.location.reload()
    })
  };

 
  const loginFields = [
    { type: 'select', name: 'shop', label: 'Shop', options:[
      {
        value:'',
        label:'Select Shop'
      },
      {
        value:'1',
        label:'Shop 1'
      },
      {
        value:'2',
        label:'Shop 2'
      },{
        value:'3',
        label:'Shop 3'
      },{
        value:'4',
        label:'Shop 4'
      },{
        value:'5',
        label:'Shop 5'
      },{
        value:'6',
        label:'Shop 6'
      },{
        value:'7',
        label:'Shop 7'
      }
    ], 
    required: true },
  ]




  return (
    <Modal
      open={open}
      onClose={handleClose}
      className=''
    >
      <Box className='bg-white mt-20 h-[90vh] fixed w-full bottom-0 rounded-t-3xl overflow-y-auto'>
        <div className='flex justify-center p-5 m-5'>
        {tabIndex === 0 && (
           <div>
           <div className='font-semi-bold text-center border-bottom'>
               <span className='text-3xl'> STOCK MANAGEMENT</span>
               <p className='text-lg'> Welcome, Please choose shop. </p>
           </div>
           <hr className="border-b-gray-200 p-3 m-3"></hr>
           <FormGenerator fields={loginFields} onSubmit={handleLoginSubmit} />
       </div>
        )}
        
        </div>
      </Box>
    </Modal>

  );
};


function normalizePhoneNumber(phone) {
  if (!phone) return phone;

  phone = phone.trim().replace(/[\s-]/g, '');
  if (phone.startsWith('+260')) {
    return phone.slice(1);
  }
  if (phone.startsWith('260')) {
    return phone;
  }
  if (phone.startsWith('09')) {
    return '260' + phone.slice(1);
  }
  if (phone.startsWith('9')) {
    return '260' + phone;
  }

  return phone;
}





function ForgotPassword({ handleTabChange }) {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false); // Loading state

  function normalizePhoneNumber(phone) {
    if (!phone) return phone;
    phone = phone.trim().replace(/[\s-]/g, "");
    if (phone.startsWith("+260")) return phone.slice(1);
    if (phone.startsWith("260")) return phone;
    if (phone.startsWith("09")) return "260" + phone.slice(1);
    if (phone.startsWith("9")) return "260" + phone;
    return phone;
  }

  const handleEmailSubmit = async () => {
    setError("");
    setIsLoading(true); // Start loading

    try {
      const response = await axios.get(rootUrl(`/forgotPassword/${email}`));

      if (response.data.message === "Email is sent!") {
        const normalizedPhone = normalizePhoneNumber(response.data.data.phone);
        setPhone(normalizedPhone);
        localStorage.setItem("verificationCode", response.data.data.code);
        setStep(2);
      } else {
        toast.error("Failed to send verification code");
      }
    } catch (err) {
      setError(err?.message);
      toast.error(err?.message);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handleCodeSubmit = () => {
    setError("");
    const storedCode = localStorage.getItem("verificationCode");
    if (code === storedCode) {
      setStep(3);
    } else {
      setError("Incorrect verification code. Please try again.");
    }
  };

  const handlePasswordSubmit = async () => {
    setError("");
    try {
      
      await axios.post(rootUrl(`/updatePassword`), { email:email,password:newPassword });
      localStorage.removeItem("verificationCode");
      handleTabChange(0);
    } catch (err) {
      setError("Failed to update password. Please try again.");
    }
  };

  return (
    <div className="max-w-md mx-auto p-4">
      <div className="font-semibold text-center pb-2 mb-4">
        <span className="text-3xl">Gramosi</span>
        <p className="text-lg">Forgot Password</p>
      </div>
      <hr className="border-b-gray-200 my-3" />

      {step === 1 && (
        <div>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border p-2 rounded w-full mb-3"
            disabled={isLoading} // Disable input when loading
          />
          <button
            onClick={handleEmailSubmit}
            className={`w-full p-2 rounded ${
              isLoading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 text-white"
            }`}
            disabled={isLoading}
          >
            {isLoading ? "Sending..." : "Send Verification Code"}
          </button>
        </div>
      )}

      {step === 2 && (
        <div>
          <p className="mb-3 text-center">
            A verification code has been sent to your email and phone ending in{" "}
            <strong>{phone.slice(-4)}</strong>.
          </p>
          <input
            type="text"
            placeholder="Enter verification code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="border p-2 rounded w-full mb-3"
          />
          <button
            onClick={handleCodeSubmit}
            className="w-full p-2 bg-blue-500 text-white rounded"
          >
            Verify Code
          </button>
        </div>
      )}

      {step === 3 && (
        <div>
          <input
            type="password"
            placeholder="Enter new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="border p-2 rounded w-full mb-3"
          />
          <button
            onClick={handlePasswordSubmit}
            className="w-full p-2 bg-blue-500 text-white rounded"
          >
            Update Password
          </button>
        </div>
      )}

      {error && <p className="text-red-500 text-center mt-3">{error}</p>}

      <div className="text-center mt-5">
        Already have an account?{" "}
        <span onClick={() => handleTabChange(0)} className="text-blue-500 cursor-pointer">
          Login
        </span>
      </div>
    </div>
  );
}




export default LoginSignupModal;
